import $ from 'jquery';
import screenSize from '../../../common/screen_size_util';


module.exports = function () {
    $(document).ready(function () {
        // Text positioning on mobile, no poster
        if ($('.ibd-column.no-poster').length && screenSize.getSize() === 'small') {
            var $col = $('.ibd-column.no-poster'),
                $title = $('.fc-company-page__fc-company-content .title'),
                colTop = $col.offset().top,
                titleTop = $title.offset().top;
            $col.css('marginTop', titleTop - colTop + $title.height() + 32);
        }

        // Sidebar positioning on desktop;
        window.setTimeout(function () {
            var largeScreen = (screenSize.getSize() !== 'small' && screenSize.getSize() !== 'medium');
            if ($('.mic-sidebar:not(.no-poster)').length && largeScreen) {
                var $sideBar = $('.mic-sidebar'),
                    headerHeight = $('.header-row').height();

                $sideBar.css('marginTop', 0 - headerHeight - 43);
            }
        }, 1000);

    });
};
